module.exports = __webpack_public_path__ + "img/login-banner.1063df2e.jpg";